import { gql } from '@apollo/client';

export const SEED_DOMAIN_STARTER_INVENTORY_MUTATION = gql`
  mutation SeedDomainStarterInventory {
    seedDomainStarterInventory {
      seededCount
      items {
        name
        costCents
      }
    }
  }
`;
